// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/time/time.js#1 $
'use strict';

angular.module('tc.time', ['tc.timeParser'])
.directive('tcTime', function() {
	return {
		restrict: 'A',
		controller: 'tcTimeCtrl',
		require: 'ngModel',
		link: function(scope, element, attrs, ngModelCtrl) {
			element.on('change', function() {
				scope.validateTime(scope, element, attrs, ngModelCtrl);
			});
		},
	};
})
.controller('tcTimeCtrl', function($scope, timeParser, GlobalService) {
	$scope.validateTime = function(originalScope, element, attrs, ngModelCtrl) {
		var timeField = element[0];
		if (angular.isUndefined(timeField)) return;
		
		var timeValue = timeField.value;
		
		var parsedTimeValue = timeParser.parse(timeValue);
		if (timeValue != '' && parsedTimeValue == '') {
			ngModelCtrl.$setValidity('time', false);
		} else {
			ngModelCtrl.$setViewValue(parsedTimeValue);
			ngModelCtrl.$setValidity('time', true);
			// if parsed time different from user entered time, alert screen reader users
			if (timeValue !== parsedTimeValue) {
				var alert = GlobalService.getGlobalStrings()['XTIMECONVERT'] + ' ' + parsedTimeValue;
				GlobalService.announce(alert, 'alert');	
			}
		}
		ngModelCtrl.$commitViewValue();
		ngModelCtrl.$render();
	};
});
